import type { AccessLevel, Folder, FolderUserUpdate } from '../../types';
import { Menu, MenuItem, MenuSection, Button, Tooltip, Icon } from '@workramp/ui';
import { ACCESS_LEVEL_NAMING_MAP } from '../../constants';
import { MenuContainer, TooltipContainer } from './PermissionsAccessLevelMenu.styles';

type Props = {
  accessLevel: AccessLevel;
  inheritedFolder: Folder | null;
  readOnly: boolean;
  onUpdate: (data: FolderUserUpdate) => void;
  userId: number | null;
  groupId: number | null;
};

export const PermissionAccessLevelMenu = ({
  onUpdate,
  accessLevel,
  readOnly,
  inheritedFolder,
  userId,
  groupId,
}: Props) => {
  const currentAccessLevel = ACCESS_LEVEL_NAMING_MAP[accessLevel];
  const accessOptions = Object.values(window.APP_CONSTANTS.FOLDER_ACCESS_LEVEL_TYPES);
  return (
    <MenuContainer>
      {inheritedFolder !== null && (
        <TooltipContainer>
          <Tooltip message={`Inherited from parent folder: ${inheritedFolder.name}`}>
            <Icon name="info:regular" />
          </Tooltip>
        </TooltipContainer>
      )}
      <Menu
        placement="bottom-end"
        zIndex={1042}
        buttonEl={
          <Button
            color="secondary"
            isDisabled={inheritedFolder !== null || readOnly}
            variant="outline"
            trailingIconName={inheritedFolder == null ? 'caret-down:regular' : undefined}
          >
            {currentAccessLevel}
          </Button>
        }
        onAction={(key: AccessLevel) => onUpdate({ userId, groupId, accessLevel: key })}
      >
        <MenuSection aria-label="access options">
          {accessOptions.map((accessLevelOption: string) => (
            <MenuItem key={accessLevelOption}>{ACCESS_LEVEL_NAMING_MAP[accessLevelOption]}</MenuItem>
          ))}
        </MenuSection>

        <MenuSection aria-label="access removal">
          <MenuItem color="danger" key="remove">
            Remove access
          </MenuItem>
        </MenuSection>
      </Menu>
    </MenuContainer>
  );
};
